import type { Partner } from "@/container/home/type/partner-type";

export type PartnerView = {
  id: number;
  name: string;
  src: string | null;
  href: string | null;
};

const DESKTOP_SLOT = 216;

export function partnerSlot(narrow: boolean): number {
  return narrow ? 176 : DESKTOP_SLOT;
}

export function partnerDuration(baseSeconds: number, narrow: boolean): number {
  return baseSeconds * (partnerSlot(narrow) / DESKTOP_SLOT);
}

export function toPartnerView(partner: Partner, index: number): PartnerView {
  const extra = partner as Partner & {
    name?: string | null;
    website?: string | null;
    url?: string | null;
    link?: string | null;
  };
  const name = typeof extra.name === "string" && extra.name.trim() ? extra.name.trim() : "partner";
  const hrefSource = extra.website || extra.url || extra.link;
  const href = typeof hrefSource === "string" && hrefSource.trim() ? hrefSource.trim() : null;
  return {
    id: partner.id ?? index,
    name,
    src: logoSrc(partner.img),
    href,
  };
}

export function fillPartnerCopy<T>(items: T[], viewportWidth: number, slot: number): T[] {
  if (items.length === 0) return [];
  const target = Math.max(viewportWidth, 1);
  const out = [...items];
  let guard = 0;
  while ((out.length < 8 || out.length * slot < target) && guard < 12) {
    out.push(...items);
    guard += 1;
  }
  return out;
}

export function rotateHalf<T>(items: T[]): T[] {
  if (items.length < 2) return items;
  const mid = Math.floor(items.length / 2);
  return [...items.slice(mid), ...items.slice(0, mid)];
}

function logoSrc(img: string | null | undefined): string | null {
  if (typeof img !== "string" || !img.trim()) return null;
  if (img.startsWith("http") || img.startsWith("/")) return img;
  return null;
}
